module.exports = __webpack_public_path__ + "img/pic27.c4d65f04.png";